import React, { useEffect, useState } from "react";
import PhoneSignin1 from "./PhoneSignin1";
import PhoneSignin2 from "./PhoneSignin2";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { Box } from "../../../../components/styled/Elements";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";

const phoneSigninSteps = [
  {
    label: "wellcome_back",
    component: PhoneSignin1,
  },
  {
    label: "we_just_texted_you",
    component: PhoneSignin2,
  },
];

const PhoneSigninForm = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(phoneSigninSteps[0]);
  const [phone, setPhone] = useState("");

  const currentStepIndex = phoneSigninSteps.indexOf(currentStep);

  const handleSteps = () => {
    if (currentStepIndex < 1)
      setCurrentStep(phoneSigninSteps[currentStepIndex + 1]);
    else return;
  };

  const handleSendOtp = async (otpFieldRef = null) => {
    try {
      const {code, message} = await AuthApi.loginWithPhone(
        {phone_number: phone}
      );

      if (code === 200) {
        otpFieldRef?.current?.resetTimer();
        handleSteps();
      }
      if(code === 204){
        toast.error(message)
      }
    } catch (error) {
    }
  };

  return (
    <Box>
      <Box id="recaptcha-container"></Box>
      <currentStep.component
        handleSteps={handleSteps}
        handleSendOtp={handleSendOtp}
        setPhone={setPhone}
      />
    </Box>
  );
};

export default PhoneSigninForm;
